import { render } from "./download.vue?vue&type=template&id=8d5f3036&scoped=true"
import script from "./download.vue?vue&type=script&lang=ts"
export * from "./download.vue?vue&type=script&lang=ts"

import "./download.vue?vue&type=style&index=0&id=8d5f3036&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-8d5f3036"

export default script